import { Spacer, Text } from '@loomhq/lens';
import React, { useMemo } from 'react';

import { MemberPropertyEnum } from 'constants/memberProperties';
import useSuggestedFollows from 'creators/follows/useSuggestedFollows';

import { useMemberProperty } from 'hooks/memberProperties';

import SuggestedProfileFollow from './SuggestedProfileFollow';
import SuggestedTagFollow from './SuggestedTagFollow';

import styles from '../styles.module.less';

const MAX_SUGGESTED_STREAMS = 5;

const SuggestedFollows = ({
  followedProfiles,
  followedTags,
  ProfileLink,
  TagLink,
}) => {
  const followedProfileIds = useMemo(
    () => new Set(followedProfiles.map(p => p.user.id)),
    [followedProfiles]
  );
  const followedTagNames = useMemo(
    () => new Set(followedTags.map(t => t.name)),
    [followedTags]
  );

  const { value: declinedStreams } = useMemberProperty(
    MemberPropertyEnum.DECLINED_SUGGESTED_FOLLOW_STREAMS
  );

  const { suggestedProfiles, suggestedTags } = useSuggestedFollows({
    followedProfileIds,
    followedTagNames,
  });

  if (!suggestedProfiles.length && !suggestedTags.length) {
    return null;
  }

  return (
    <>
      <div className={styles.librariesHeading}>
        <Spacer bottom="small" left="xsmall">
          <Text fontWeight="medium" color="bodyDimmed">
            Suggested
          </Text>
        </Spacer>
      </div>

      {suggestedProfiles
        .slice(0, MAX_SUGGESTED_STREAMS - followedProfileIds.size)
        .map(profile => (
          <SuggestedProfileFollow
            key={profile.user.id}
            profile={profile}
            ProfileLink={ProfileLink}
            declinedStreams={declinedStreams}
          />
        ))}

      {suggestedTags
        .slice(0, MAX_SUGGESTED_STREAMS - followedTagNames.size)
        .map(tag => (
          <SuggestedTagFollow
            key={tag.name}
            tag={tag}
            TagLink={TagLink}
            declinedStreams={declinedStreams}
          />
        ))}
    </>
  );
};

export default SuggestedFollows;
